"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.date.to-string.js");

require("core-js/modules/es.parse-int.js");

require("core-js/modules/es.regexp.constructor.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.regexp.to-string.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.number.constructor.js");

/*
 * 时间处理，主要是时间格式的相互转换
 * 通过js获取的时间戳单位都是毫秒，我们传给后端的时间戳也是毫秒级的
 */
var Time = {
  /**
   * @function Time[format] - 时间戳转时间格式
   * @param {number} stamp 时间戳, 也可以不传，默认当前时间
   * @param {string} format 时间显示格式，以为10以下数字不加0，两位自动补0
   * @example
   * import { Time } from '@zz-biz/utils';
   * 
   * Time.format(132323331222, 'yyyy-mm-dd hh:mm:ss');
   * 
   * // 2018-12-12 10:08:09
   * 
   * // yyyy-mm-dd hh:mm:ss  2018-12-12 10:08:09
   * // yyyy-mm-dd h:m:s  2018-12-12 9:8:9 
   * // yyyy-mm-dd  2018-12-02 
   * // yyyy-m-d  2018-1-3
   * // yyyy/mm/dd  2018/12/02 
   * // yyyy/m/d  2018/1/3
   * // yyyy年m月d日 2019年10月4日
   * // yyyy年m月d日 hh时mm分ss秒 2019年10月4日 10点02分03秒
   * @return {string}
   */
  format: function format(stamp) {
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy-mm-dd hh:mm:ss';

    var formatUnitTime = function formatUnitTime(a) {
      return a < 10 ? "0".concat(a) : a;
    };

    var formatTime = '';
    var date = stamp ? new Date(parseInt(stamp, 10)) : new Date();
    var Y = date.getFullYear();
    var M = date.getMonth() + 1;
    var D = date.getDate();
    var h = date.getHours();
    var m = date.getMinutes();
    var s = date.getSeconds();
    var reg = new RegExp(/^(y{4})?([^my])?(m{1,2})?([^dm])?(d{1,2})?([^\s])?(\s+(h{1,2})?([^mh])?(m{1,2})?([^ms])?(s{1,2})?(.)?)?$/i);
    format.replace(reg, function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var year = args[1],
          Yjoiner = args[2],
          month = args[3],
          Mjoiner = args[4],
          date = args[5],
          Djoiner = args[6],
          hour = args[8],
          hjoiner = args[9],
          minute = args[10],
          mjoiner = args[11],
          second = args[12],
          sjoiner = args[13];
      formatTime = "".concat(year ? Y : '').concat(Yjoiner ? Yjoiner : '').concat(month ? month.length === 2 ? formatUnitTime(M) : M : '').concat(Mjoiner ? Mjoiner : '').concat(date ? date.length === 2 ? formatUnitTime(D) : D : '').concat(Djoiner ? Djoiner : '').concat(hour ? ' ' : '').concat(hour ? hour.length === 2 ? formatUnitTime(h) : h : '').concat(hjoiner ? hjoiner : '').concat(minute ? minute.length === 2 ? formatUnitTime(m) : m : '').concat(mjoiner ? mjoiner : '').concat(second ? second.length === 2 ? formatUnitTime(s) : s : '').concat(sjoiner ? sjoiner : '');
    });
    return formatTime;
  },

  /**
   * @function Time[StopWatch] - 秒表展示(时：分：秒)
   * @param {number} miniSenconds 毫秒
   * @param {string} [separation=:] 分隔符
   * @example
   * import { Time } from '@zz-biz/utils';
   * 
   * Time.stopWatch(132323331222);
   * 
   * // 10:08:09
   * Time.stopWatch(132323331222, '-');
   * 
   * // 10-08-09
   * @return {string}
   */
  stopWatch: function stopWatch() {
    var miniSenconds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var separation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ':';

    try {
      // console.log('事件格式化', time);
      var time = Math.abs(miniSenconds / 1000);
      var temp = Math.floor(Number(time) / 60);
      var hour = Math.floor(temp / 60);
      var mini = Math.floor(Number(temp) % 60);
      var seconds = Math.floor(Number(time) % 60);

      var setShowText = function setShowText(curTime) {
        var hasColon = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        var text = "00".concat(separation);

        if (curTime) {
          text = "".concat(curTime < 10 ? '0' : '').concat(curTime).concat(hasColon ? separation : '');
        }

        return text;
      };

      return "".concat(miniSenconds < 0 ? '-' : '').concat(setShowText(hour)).concat(setShowText(mini)).concat(setShowText(seconds, false));
    } catch (err) {
      console.log(err);
      return '';
    }
  }
};
var _default = Time;
exports["default"] = _default;